import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSlidersH, faCampground, faHouseDamage, faCaravan, faMountain  } from "@fortawesome/free-solid-svg-icons";

import useStore from "hooks/useStore";

interface Props {
  setListType: any;
  openFilter: any;
  openMap: any;
  mapIsOpen: boolean;
  filterCount: number;
  title: string;
  pageType: string;
}

interface TabbarInput {
  active?: boolean;
}

interface FilterInput {
  count?: number;
}

const ListHeader = ({
  setListType,
  openFilter,
  openMap,
  mapIsOpen,
  filterCount,
  title = "Kamp Alanları",
  pageType,
}: Props) => {
  const { selectedListType, setSelectedListType } = useStore();

  const selectedListItem = (value: string) => {
    setListType(value);
    setSelectedListType(value);
  };

  return (
    <HeaderContainer>
      {pageType === "list" ? (
        <TabbarContainer>
          <TabbarItem
            onClick={() => selectedListItem("camping")}
            active={selectedListType === "camping"}
          >
            <HeaderIcon
              src="/images/camp_icon.png"
              alt="camp_icon"
              width="20"
              height="20"
            />
            {title || "Kamp Alanları"}
          </TabbarItem>
          <TabbarItem
            onClick={() => selectedListItem("facility")}
            active={selectedListType === "facility"}
          >
            <HeaderIcon
              src="/images/facility_icon.png"
              alt="facility_icon"
              width="20"
              height="20"
            />
            {title || "Kampingler"}
          </TabbarItem>
          <TabbarItem
            onClick={() => selectedListItem("glamping")}
            active={selectedListType === "glamping"}
          >
            <HeaderIcon
              src="/images/glamping_icon.png"
              alt="galmping_icon"
              width="20"
              height="20"
            />
            {title || "Glampingler"}
          </TabbarItem>
          <TabbarItem
            onClick={() => selectedListItem("caravan")}
            active={selectedListType === "caravan"}
          >
            <HeaderIcon
              src="/images/caravan_icon.png"
              alt="caravan_icon"
              width="20"
              height="20"
            />
            {title || "Karavan Alanları"}
          </TabbarItem>
          <TabbarItem
            onClick={() => selectedListItem("bunglow")}
            active={selectedListType === "bunglow"}
          >
            <HeaderIcon
              src="/images/hut_icon.png"
              alt="hut_icon"
              width="20"
              height="20"
            />
            {title || "Bungalovlar"}
          </TabbarItem>
        </TabbarContainer>
      ) : (
        <TabbarContainer>
          <TabbarItem onClick={() => {}} active={true}>
            {title}
          </TabbarItem>
        </TabbarContainer>
      )}
      <OptionContainer>
        {/* <FilterContainer onClick={openMap}>
          <FilterIcon icon={mapIsOpen ? faListUl : faMap} inverse />
          <FilterText>
            {mapIsOpen ? "Liste Görünümü" : "Harita Görünümü"}
          </FilterText>
        </FilterContainer> */}
        <FilterContainer onClick={openFilter} count={filterCount}>
          <FilterIcon icon={faSlidersH} />
          <FilterText>Filtreler</FilterText>
          {filterCount > 0 && <FilterCount>{filterCount}</FilterCount>}
        </FilterContainer>
      </OptionContainer>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  padding: 14px 15% 0px 15%;
  background-color: white;
  z-index: 5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px;
  @media (max-width: ${(props) => props.theme.size.tablet}) {
    padding: 20px 30px;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    overflow-x: scroll;
  }
`;

const TabbarContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 520px;
`;

const TabbarItem = styled.div<TabbarInput>`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  padding: 10px 5px;
  border-bottom: ${(props) => (props.active ? "2px solid black" : "none")};
  color: ${(props) => (props.active ? "black" : "rgb(113,113,113)")};
  margin-right: 20px;
  min-width: revert;
`;

const OptionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: ${(props) => props.theme.size.tablet}) { 
    display: none;
  }
`;

const FilterContainer = styled.div<FilterInput>`
  display: flex;
  position: relative;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer !important;
  text-align: center !important;
  border: ${(props) =>
    props.count && props.count > 0
      ? "2px solid rgb(34,34,34)"
      : "1px solid rgb(221, 221, 221)"};
  background-color: rgb(255, 255, 255) !important;
  outline: none !important;
  padding: 10px 16px !important;
  border-radius: 30px !important;
  font-size: 14px !important;
  line-height: 16px !important;
  margin-left: 15px;
`;

const FilterCount = styled.div`
  position: absolute;
  font-size: 9px !important;
  line-height: 13px !important;
  font-weight: 700 !important;
  background-color: rgb(34, 34, 34) !important;
  color: rgb(255, 255, 255) !important;
  border-radius: 50% !important;
  width: 18px !important;
  height: 18px !important;
  text-align: center !important;
  border: 2px solid rgb(255, 255, 255) !important;
  margin-left: -15px !important;
  z-index: 2 !important;
  right: 0;
  top: -9px;
}`;

const FilterText = styled.span`
  @media (max-width: ${(props) => props.theme.size.laptop}) {
    display: none;
  }
`;

const FilterIcon = styled(FontAwesomeIcon)`
  width: 14px;
  height: 14px;
  margin-right: 6px;
  @media (max-width: ${(props) => props.theme.size.laptop}) {
    margin-right: 0px;
  }
  * {
    // color: red;
  }
`;

const HeaderIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-bottom: 6px;
`;

export default ListHeader;
